import { ENV_TYPE, EXPERIMENT_API_DEV, EXPERIMENT_API_PROD, status, XLABS_API_KEY, EXPERIMENT_WORKSPACE_ID } from "./constants";
import axios from "axios";
import { getStorageData, setStorageData } from "./storage/storageUtils";
import getAmplitudeInstance from "./getAmplitudeInstance";
let globalWindow = globalThis.window || {};

let amplitudeUserAttributes = {};

const fetchExperimentData = (type, requestData) => {
  const {PWA_WORKSPACE_ID, MAIN_ACCOUNT_ID, TENANAT_ID, USER_INFO} = requestData;
  const {userId, isLoggedIn} = USER_INFO || {};
  if (!userId || !isLoggedIn) {
    return;
  }
  const payload = {
      mainAccountInfo: {
        accountId: MAIN_ACCOUNT_ID
      },
      tenantInfo: {
        tenantId: TENANAT_ID
      },
      workspaceInfos: {
        [PWA_WORKSPACE_ID]: {
          workspaceId: PWA_WORKSPACE_ID,
          identifier: userId
        }
      }
  };
  const url = type === ENV_TYPE.devEnv ? EXPERIMENT_API_DEV : EXPERIMENT_API_PROD;

  const headers = {
    'Content-Type': 'application/json', // Specify the content type
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
    'Access-Control-Allow-Headers': '*',
    'xlabs_api_key': XLABS_API_KEY
  };

  axios.post(url, payload, { headers })
    .then(response => {
      const timestamp = new Date().getTime();
      const xlabsData = {...response.data, timestamp: timestamp}
      console.log('Success:', xlabsData);
      setStorageData('xLabsResponse', xlabsData);
      return {
        status: status.SUCCESS,
        data: xlabsData
      };
    })
    .catch(error => {
      console.error('Error:', error);
      return {
        status: status.FAILURE,
        error: error.errorDescription
      };
    });
}

const getVariationNameForCampaign = (workspaceId, campaignKey) => {
  // Fetch variation name from campaign key
  try {
    const {timestamp, variationResponse} = getStorageData('xLabsResponse');
    let variationName = '';
    if(!variationResponse){
      console.error('Error: Please launch the SDK first');
      return;
    }
    const workspaceInfoObj = variationResponse[workspaceId] || null;
    if (workspaceInfoObj) {
      // check from global experiment first
      variationName = workspaceInfoObj[campaignKey]?.variation?.name || '';
  
      if (!variationName) {
        const campaignKeys = Object.keys(workspaceInfoObj);
        const campaignKeysLen = campaignKeys.length;
  
        for (let j = 0; j < campaignKeysLen; j++) {
          const currentCampaignKey = campaignKeys[j];
          const childCampaignsVariationResponse =
            workspaceInfoObj[currentCampaignKey]
              ?.childCampaignsVariationResponse;
          variationName =
            childCampaignsVariationResponse[campaignKey].variation?.name;
          break;
        }
      }
    }
    return variationName || 'NA';
  }
  catch(err) {
    console.error(err);
  } 

}

const getVariationIdentifierForCampaignKey = (workspaceId, campaignKey) => {
   // Fetch variation name from campaign key
   try {
    const {timestamp, variationResponse} = getStorageData('xLabsResponse');
    let variationId = '';
    if(!variationResponse){
      console.error('Error: Please launch the SDK first');
      return;
    }
    const workspaceInfoObj = variationResponse[workspaceId] || null;
    if (workspaceInfoObj) {
      // check from global experiment first
      variationId = workspaceInfoObj[campaignKey]?.variation?.identifier || '';
  
      if (!variationId) {
        const campaignKeys = Object.keys(workspaceInfoObj);
        const campaignKeysLen = campaignKeys.length;
  
        for (let j = 0; j < campaignKeysLen; j++) {
          const currentCampaignKey = campaignKeys[j];
          const childCampaignsVariationResponse =
            workspaceInfoObj[currentCampaignKey]
              ?.childCampaignsVariationResponse;
          variationId =
            childCampaignsVariationResponse[campaignKey].variation?.identifier;
          break;
        }
      }
    }
    return variationId || 'NA';
  }
  catch(err) {
    console.error(err);
  } 
}

const getAmplitudeValueForCampaign = (workspaceId, campaignKey) => {
  try {
    const {timestamp, variationResponse} = getStorageData('xLabsResponse');
    if(!variationResponse){
      console.error('Error: Please launch the SDK first');
      return;
    }
    let variationName = '';
    let amplitudeKey = '';
    const workspaceInfoObj = variationResponse[workspaceId] || null;
    if (workspaceInfoObj) {
      // check from global experiment first
      variationName =
        workspaceInfoObj[campaignKey]?.variation?.identifier || '';
      const variableList = workspaceInfoObj[campaignKey]?.variableList || [];
      const vdata = variableList.find(item => item.key === 'amplitude_key');
      amplitudeKey = vdata?.value;

      if (!variationName) {
        const campaignKeys = Object.keys(workspaceInfoObj);
        const campaignKeysLen = campaignKeys.length;

        for (let j = 0; j < campaignKeysLen; j++) {
          const currentCampaignKey = campaignKeys[j];
          const childCampaignsVariationResponse =
            workspaceInfoObj[currentCampaignKey]
              ?.childCampaignsVariationResponse;
          variationName =
            childCampaignsVariationResponse[campaignKey]?.variation?.identifier;
          const variableList =
            childCampaignsVariationResponse[campaignKey]?.variableList || [];
          const vdata = variableList.find(item => item.key === 'amplitude_key');
          amplitudeKey = vdata?.value;
          break;
        }
      }
    }
        return amplitudeKey || '';
      // setSessionStorageValue(
      //   `${campaignKey}_amp_key`,
      //   JSON.stringify(amplitudeKey)
      // );
      // setSessionStorageValue(
      //   `${campaignKey}_amp_val`,
      //   JSON.stringify(variationName || 'NA')
      // );
      // setUserAttributesInAmplitude({
      //   [amplitudeKey]: variationName || 'NA'
      // });
  } catch (error) {
    console.log('Error in getVariationNameForCampaignKey', error);
  }
}

const setUserPropertyValueInAmplitude = (workspaceId, campaignKey) => {
  const amplitudeKey = getAmplitudeValueForCampaign(workspaceId, campaignKey) || '';
  const variationId = getVariationIdentifierForCampaignKey(workspaceId, campaignKey) || 'NA';
  const userAttributes = {
     [amplitudeKey] : variationId
  }
  setUserAttributesInAmplitude(userAttributes);
}

const setUserAttributesInAmplitude = (userAttributes = {}) => {
  try {
      const amplitudeClient = getAmplitudeInstance();
      const userId = userAttributes?.user_id;
      if (globalWindow?.amplitudeInitialized) {
        if (userId) {
          amplitudeClient.setUserId(userId);
        }
        amplitudeClient.setUserProperties(userAttributes);
        persistAmplitudeUserAttributes(userAttributes);
      }
  } catch (error) {
    console.log('ERROR: COULD NOT SET USER ATTRIBUTES IN AMPLITUDE', error);
  }
};

const persistAmplitudeUserAttributes = userAttributes => {
  amplitudeUserAttributes = { ...amplitudeUserAttributes, ...userAttributes };
  globalWindow.amplitudeUserAttributes = amplitudeUserAttributes;
};

export {fetchExperimentData, getVariationNameForCampaign, getVariationIdentifierForCampaignKey, getAmplitudeValueForCampaign, setUserPropertyValueInAmplitude};